import { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import auth from "../services/auth/AuthProvider";
import UserActions from "store/userRedux";
let authInitialized = false;

const useAuthProvider = () => {
    const [isReady, setIsReady] = useState(authInitialized);
    const dispatch = useDispatch();

    const configuration = useSelector((state) => state?.configuration?.configuration, shallowEqual);

    useEffect(() => {
        const initializeAuth = async () => {
            if (configuration && !authInitialized) {
                await auth.initProvider(configuration);
                dispatch(UserActions.setUserProfile(auth.getProfile()));
                authInitialized = true;
                setIsReady(true);
            }
        };
        initializeAuth();
    }, [configuration, dispatch]);

    return isReady;
};

export default useAuthProvider;
